import React from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { analytics } from 'core/analytics';

import { Divider, SettingsSection } from 'legacyComponents/styled/lib';

import { SectionTitle } from 'apps/group/styles';

import { AddPaymentMethodLink } from 'apps/payment/styles';
import { CreditCard, DeleteButton } from 'apps/payment/views/creditCard';
import { Button, Spinner, Paragraph } from 'components';
import { PaymentMethodsAppManager } from 'apps/payment/method/appManager';
import { NewCardForm } from 'apps/payment/method/newCardForm';

class UIState {
  @observable showAddPaymentForm = false;
}

@withNamespaces()
@observer
export class PaymentMethodsInfo extends React.Component {
  constructor(props) {
    super(props);
    this.manager = new PaymentMethodsAppManager(this, props);
    this.UIState = new UIState();
  }

  @action addPaymentMethod = () => {
    analytics.sendEvent(
      'InitiateCheckout',
      { value: 5, currency: 'EUR' },
      { twitter: true, facebook: true },
    );
    analytics.linkedinPixel('1169161');
    this.UIState.showAddPaymentForm = true;
  };

  render() {
    const { loading, paymentSpace } = this.manager;

    if (loading || !paymentSpace) {
      return <Spinner margin='20px auto' />;
    }

    const { creditCards } = paymentSpace;

    let newCardForm = (
      <AddPaymentMethodLink onClick={this.addPaymentMethod}>
        <Trans>Add new payment method</Trans>
      </AddPaymentMethodLink>
    );
    if (this.UIState.showAddPaymentForm) {
      newCardForm = (
        <NewCardForm paymentMethodsManager={this.manager} responsive />
      );
    }
    if (creditCards.length === 0) {
      return (
        <>
          <Paragraph>
            <Trans>No payment methods on file</Trans>.{' '}
          </Paragraph>
          {newCardForm}
        </>
      );
    }
    return (
      <>
        {creditCards.map(card => {
          const activeButton = card.isDefault ? (
            <Button
              text={<Trans>Default</Trans>}
              size='small'
              customBgColor='#27ae60'
            />
          ) : (
            <Button
              text={<Trans>Make default</Trans>}
              size='small'
              customColor='#27ae60'
              variant='secondary'
              onClick={card.MakeDefault}
              outline
            />
          );

          return (
            <CreditCard key={card.id} cardObject={card}>
              <DeleteButton onClick={card.ConfirmDelete}>
                <Trans>Delete</Trans>
              </DeleteButton>
              {activeButton}
            </CreditCard>
          );
        })}
        {newCardForm}
      </>
    );
  }
}

@withNamespaces()
@inject('routerStore')
@observer
export class PaymentMethods extends React.Component {
  render() {
    const {
      routerStore: { params },
    } = this.props;
    const spaceSlug = params.get('spacePath');

    return (
      <SettingsSection>
        <SectionTitle level={2} size='medium'>
          <Trans>Payment Methods</Trans>:
        </SectionTitle>
        <FullWidthDivider />
        <PaymentMethodsInfo spaceSlug={spaceSlug} />
      </SettingsSection>
    );
  }
}

const FullWidthDivider = styled(Divider)`
  width: 100%;
  margin-bottom: 20px;
`;

PaymentMethods.propTypes = {
  routerStore: PropTypes.object,
};
